import { reportsApi } from '../services/api'
import { offlineStorage } from '../services/offlineStorage'

export interface DraftInfo {
  hasDraft: boolean
  type: 'server' | 'offline' | null
  draftId?: string
}

/**
 * Check if there are existing hourly report drafts (server or offline)
 */
export const checkForHourlyReportDrafts = async (): Promise<DraftInfo> => {
  try {
    // First check for offline drafts
    const offlineDraft = offlineStorage.getLocalReportDraft('hourly')
    if (offlineDraft) {
      console.log('📱 Found offline hourly draft:', offlineDraft.localId)
      return {
        hasDraft: true,
        type: 'offline',
        draftId: offlineDraft.localId
      }
    }

    // Then check server drafts if online
    if (navigator.onLine) {
      try {
        const draftsResponse = await reportsApi.getDraftHourlyReports()
        const serverDrafts = draftsResponse?.data || []

        if (serverDrafts.length > 0) {
          console.log('📋 Found server hourly drafts:', serverDrafts.length)
          return {
            hasDraft: true,
            type: 'server',
            draftId: serverDrafts[0].id // Most recent draft
          }
        }
      } catch (error) {
        console.log('Failed to check server drafts:', error)
      }
    }

    return {
      hasDraft: false,
      type: null
    }
  } catch (error) {
    console.error('Error checking for hourly report drafts:', error)
    return {
      hasDraft: false,
      type: null
    }
  }
}

/**
 * Check if there are existing incident report drafts (server or offline)
 */
export const checkForIncidentReportDrafts = async (): Promise<DraftInfo> => {
  try {
    // First check for offline drafts
    const offlineDraft = offlineStorage.getLocalReportDraft('incident')
    if (offlineDraft) {
      console.log('📱 Found offline incident draft:', offlineDraft.localId)
      return {
        hasDraft: true,
        type: 'offline',
        draftId: offlineDraft.localId
      }
    }

    // Then check server drafts if online
    if (navigator.onLine) {
      try {
        const draftsResponse = await reportsApi.getDraftIncidentReports()
        const serverDrafts = draftsResponse?.data || []

        if (serverDrafts.length > 0) {
          console.log('📋 Found server incident drafts:', serverDrafts.length)
          return {
            hasDraft: true,
            type: 'server',
            draftId: serverDrafts[0].id // Most recent draft
          }
        }
      } catch (error) {
        console.log('Failed to check server drafts:', error)
      }
    }

    return {
      hasDraft: false,
      type: null
    }
  } catch (error) {
    console.error('Error checking for incident report drafts:', error)
    return {
      hasDraft: false,
      type: null
    }
  }
}

